import React from "react";
import Flagship from "../../core/flagship";
import { connect } from "react-redux";
import {
  Loader,
  Header,
  Grid,
  Modal,
  Button,
  Icon,
  Label,
  Image,
} from "semantic-ui-react";
import {
  empty,
  getServiceNiceName,
  renderFieldValue,
  shouldShowField,
} from "../../utils/helpers";
import Linkify from "react-linkify";
import RegisterCampaignModal from "./RegisterCampaignModal";
import EditCampaignModal from "./EditCampaignModal";

class IoProductViewModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.editName = this.editName.bind(this);
    this.handleRegisterClose = this.handleRegisterClose.bind(this);
    this.handleEditCampaignClose = this.handleEditCampaignClose.bind(this);
    this.getIsFlighted = this.getIsFlighted.bind(this);
    this.onChangeAdAccount = this.onChangeAdAccount.bind(this);
    this.onChangeMediaSpendAccount = this.onChangeMediaSpendAccount.bind(this);
  }

  getInitialState() {
    return {
      flighted: false,
      loading: true,
      id: this.props.ioProductId,
      run_out_of_client_ad_account:
        this.props.ioProduct.run_out_of_client_ad_account || false,
      spend_out_of_client_account:
        this.props.ioProduct.spend_out_of_client_account || false,
      io_product_key: "",
      io_product_name: "",
      io_product_type: "",
      parent_rfp: 0,
      vendor: "",
      cogs: "",
      price: "",
      ioProductForm: {},
      ioProductData: [],
      errors: [],
      campaigns: null,
      registeringCampaign: false,
      editingCampaign: false,
    };
  }

  componentDidMount() {
    // Get Form
    this.getIoProductForm();
    this.getIsFlighted();
  }

  getIsFlighted() {
    let flighted = false;
    let self = this;
    Flagship.config.lineItemServices.map(function (element) {
      if (element.value === self.props.ioProduct.io_product_type) {
        flighted = element.flighted || false;
      } else if (element.hasOwnProperty("subOptions")) {
        element.subOptions.map(function (subItem) {
          if (subItem.value === self.props.ioProduct.io_product_type) {
            flighted = subItem.flighted || false;
          }
        });
      }
    });

    let newState = Object.assign({}, this.state);
    newState.flighted = flighted;
    this.setState(newState);
  }

  getCampaigns() {
    const self = this;

    Flagship.get(
      "registered-campaigns",
      {
        io_product_id: this.props.ioProduct.id,
      },
      function (response) {
        if (response.data.success === true) {
          let newState = Object.assign({}, self.state);
          newState.campaigns = response.data.results;
          self.setState(newState);
        } else {
          console.error("Failed to get dropdown options.");
          self.setState({
            loading: false,
          });

          Flagship.notify("Error getting registered campaigns.", "error");
        }
      },
      function (err) {
        console.error(err);
        Flagship.notify("Error getting registered campaigns.", "error");
      },
    );
  }

  getIoProductForm() {
    let self = this;
    let service = this.props.ioProduct.io_product_type;

    let mainService = false;
    let subService = false;

    Flagship.config.lineItemServices.map(function (element) {
      if (element.value === service) {
        mainService = service;
      } else if (element.hasOwnProperty("subOptions")) {
        element.subOptions.map(function (subItem) {
          if (subItem.value === service) {
            mainService = element.value;
            subService = service;
          }
        });
      }
    });

    if (subService !== false) {
      // If dealing with a sub-service, get both levels of fields
      this.getFormSubService(mainService, subService);
    } else {
      Flagship.get(
        "fields/io-product_" + mainService,
        {
          withData:
            typeof this.props.ioProductId === "undefined"
              ? false
              : this.props.ioProductId,
          dataSource: "io_product",
          instance: this.props.instance,
        },
        function (response) {
          if (response.data.success === true) {
            self.setState({
              loading: false,
              ioProductData: response.data.fieldData,
              originalIoProductData: response.data.fieldData,
              ioProductForm: response.data.results,
            });
          } else {
            Flagship.error(
              "Error getting line item form from Flagship API server.",
              self.props.recordId,
              self.props.userId,
            );
          }
        },
        function (err) {
          Flagship.error(
            "Error getting line item form from Flagship API server: " + err,
            self.props.recordId,
            self.props.userId,
          );
        },
      );
    }
    self.getCampaigns();
  }

  getFormSubService(mainService, subService) {
    let self = this;

    // First get main service fields
    Flagship.get(
      "fields/io-product_" + mainService,
      {
        withData:
          typeof this.props.ioProductId === "undefined"
            ? false
            : this.props.ioProductId,
        dataSource: "io_product",
      },
      function (response) {
        if (response.data.success === true) {
          self.setState(
            {
              ioProductForm: response.data.results,
              ioProductData: response.data.fieldData,
              originalIoProductData: response.data.fieldData,
            },
            function () {
              self.getSubServiceFields(subService);
            },
          );
        } else {
          Flagship.error(
            "Error getting IO product form from Flagship API server.",
            self.props.recordId,
            self.props.userId,
          );
        }
      },
      function (err) {
        Flagship.error(
          "Error getting IO product form from Flagship API server: " + err,
          self.props.recordId,
          self.props.userId,
        );
      },
    );
  }

  getSubServiceFields(subService) {
    let self = this;

    // Now add sub service fields
    Flagship.get(
      "fields/io-product_" + subService,
      {
        withData:
          typeof this.props.ioProductId === "undefined"
            ? false
            : this.props.ioProductId,
        dataSource: "io_product",
      },
      function (response) {
        if (response.data.success === true) {
          let combinedForm = [
            ...self.state.ioProductForm,
            ...response.data.results,
          ];
          let combinedData = Object.assign(
            self.state.ioProductData,
            response.data.fieldData,
          );

          self.setState({
            ioProductForm: combinedForm,
            ioProductData: combinedData,
            loading: false,
          });
        } else {
          Flagship.error(
            "Error getting IO product form (sub-service) from Flagship API server.",
            self.props.recordId,
            self.props.userId,
          );
        }
      },
      function (err) {
        Flagship.error(
          "Error getting IO product form (sub-sevice) from Flagship API server: " +
            err,
          self.props.recordId,
          self.props.userId,
        );
      },
    );
  }

  onChange(e, data, field) {
    let parentOnChange = this.props.onChange;

    let newState = Object.assign({}, this.state);

    newState[field] = data;

    this.setState(newState, function () {
      parentOnChange(this.state);
    });
  }

  handleRegister(registering = true) {
    let newState = Object.assign({}, this.state);
    newState.registeringCampaign = registering;
    this.setState(newState);
  }

  onChangeAdAccount(e) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    e.persist();
    // Optimistically update state
    let newState = Object.assign({}, this.state);
    newState.run_out_of_client_ad_account = e.target.checked;
    this.setState(newState);
    let self = this;

    // Now update in DB
    Flagship.post(
      "/io-product/ad-account/" + this.props.ioProduct.id,
      {
        io_product_id: this.props.ioProduct.id,
        run_out_of_client_ad_account: e.target.checked,
      },
      function (response) {
        if (response.data.success === true) {
          Flagship.notify("Updated our records. Thanks!", "success");

          // Note: if a campaign is not running out of the client ad account, the spend can't come from the client account either.
          // The API endpoint will handle this logic for the keeping the DB up to date. But we should still update state.
          // Let's always reset to false just in case.
          let newState = Object.assign({}, self.state);
          newState.spend_out_of_client_account = false;
          self.setState(newState);
        } else {
          // Revert state change since the update failed
          let newState = Object.assign({}, self.state);
          newState.run_out_of_client_ad_account = !e.target.checked;
          self.setState(newState);
          Flagship.error(
            "Failed to update IO product data...",
            self.props.recordId,
            self.props.userId,
          );
        }
      },
      function (err) {
        // Revert state change since the update failed
        let newState = Object.assign({}, self.state);
        newState.run_out_of_client_ad_account = !e.target.checked;
        self.setState(newState);
        Flagship.error(
          "Error updating IO product data: " + err,
          self.props.recordId,
          self.props.userId,
        );
      },
    );
  }
  onChangeMediaSpendAccount(e) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    e.persist();
    let newState = Object.assign({}, this.state);
    newState.spend_out_of_client_account = e.target.checked;
    this.setState(newState);
    let self = this;

    // Now update in DB
    Flagship.post(
      "/io-product/ad-account/" + this.props.ioProduct.id,
      {
        io_product_id: this.props.ioProduct.id,
        spend_out_of_client_account: e.target.checked,
      },
      function (response) {
        if (response.data.success === true) {
          Flagship.notify("Updated our records. Thanks!", "success");
        } else {
          // Revert state change since the update failed
          let newState = Object.assign({}, self.state);
          newState.spend_out_of_client_account = !e.target.checked;
          self.setState(newState);
          Flagship.error(
            "Failed to update IO product data...",
            self.props.recordId,
            self.props.userId,
          );
        }
      },
      function (err) {
        // Revert state change since the update failed
        let newState = Object.assign({}, self.state);
        newState.spend_out_of_client_account = !e.target.checked;
        self.setState(newState);
        Flagship.error(
          "Error updating IO product data: " + err,
          self.props.recordId,
          self.props.userId,
        );
      },
    );
  }

  handleEditCampaign(campaign) {
    let newState = Object.assign({}, this.state);
    newState.editingCampaign = campaign;
    this.setState(newState);
  }

  handleRegisterClose() {
    let newState = Object.assign({}, this.state);
    newState.registeringCampaign = false;
    this.setState(newState);
    this.getCampaigns();
  }

  handleEditCampaignClose() {
    let newState = Object.assign({}, this.state);
    newState.editingCampaign = false;
    this.setState(newState);
    this.getCampaigns();
  }

  editName() {
    this.setState({
      editingName: true,
    });
  }

  render() {
    let self = this;

    if (this.state.loading === true) {
      return <Loader />;
    } else {
      let userRole = this.props.userRole;
      let serviceNiceName = getServiceNiceName(
        this.props.ioProduct.io_product_type,
      );

      return (
        <div>
          <Modal
            open={this.props.open}
            onClose={this.props.cancelUpdate}
            closeIcon
          >
            {this.props.userRole !== "ae" &&
            this.props.accessLevel === 2 ? (
              <Button
                floated="right"
                className="view-edit-io-product"
                onClick={this.props.swapToEdit}
              >
                <Icon name="edit" />
                Edit IO Product
              </Button>
            ) : null}
            <Header>
              {this.props.ioProduct.io_product_key +
                " - " +
                this.props.ioProduct.io_product_name}
              {serviceNiceName !== this.props.ioProduct.io_product_name ? (
                <div className="gray-text">
                  <small> ({serviceNiceName}) </small>
                </div>
              ) : null}
            </Header>

            <Modal.Content>
              <div>
                <Grid stackable reversed="computer" columns="equal">
                  <Grid.Column width={6} computer={6} mobile={16}>
                    {(userRole === "dpm" ||
                    userRole === "social" ||
                    userRole === "csm" ||
                    userRole === "admin") && this.props.accessLevel === 2 ? (
                      <div
                        className="view-assignee-right"
                        style={{ marginTop: ".125rem" }}
                      >
                        <h4>Assigned To</h4>
                        <Label
                          className="assignee-label"
                          onClick={() => {
                            this.props.onChangeAssignee(this.props.ioProduct);
                          }}
                        >
                          {empty(this.props.ioProduct.assignee) ? (
                            <div>
                              <Icon color="black" circular name="user" />
                              Unassigned
                              <Icon
                                name="caret down"
                                fitted
                                className="icon-down float-right"
                              />
                            </div>
                          ) : (
                            <div>
                              <Image
                                src={
                                  Flagship.config.uploads +
                                  (!empty(this.props.ioProduct.photo)
                                    ? this.props.ioProduct.photo
                                    : "someone.png")
                                }
                                size="mini"
                                className="circular assignee-image"
                              />
                              {this.props.ioProduct.first_name +
                                " " +
                                this.props.ioProduct.last_name}
                              <Icon
                                name="caret down"
                                fitted
                                className="icon-down float-right"
                              />
                            </div>
                          )}
                        </Label>
                      </div>
                    ) : (
                      <div>
                        <Label className="assignee-label">
                          {empty(this.props.ioProduct.assignee) ? (
                            <div>
                              <Icon color="black" circular name="user" />
                              Unassigned
                            </div>
                          ) : (
                            <div>
                              <Image
                                src={
                                  Flagship.config.uploads +
                                  (!empty(this.props.ioProduct.photo)
                                    ? this.props.ioProduct.photo
                                    : "someone.png")
                                }
                                size="mini"
                                className="circular assignee-image"
                              />
                              {this.props.ioProduct.first_name +
                                " " +
                                this.props.ioProduct.last_name}
                            </div>
                          )}
                        </Label>
                      </div>
                    )}
                    {((userRole === "dpm" ||
                      userRole === "social" ||
                      userRole === "admin") &&
                      this.state.flighted) ||
                    this.props.ioProduct.io_product_type === "seo-local" ? (
                      <div style={{ marginTop: "2rem" }}>
                        <h4 style={{ marginBottom: "0" }}>Campaigns</h4>
                        {this.state.flighted ? (
                          <div style={{ margin: ".5rem 0" }}>
                            <div style={{ marginBottom: ".5rem" }}>
                              <input
                                type="checkbox"
                                id="run-out-of-client-ad-account"
                                checked={
                                  this.state.run_out_of_client_ad_account
                                }
                                disabled={this.props.accessLevel !== 2}
                                style={{ padding: ".5rem", cursor: "pointer" }}
                                onChange={(e) => {
                                  this.onChangeAdAccount(e);
                                }}
                              />
                              <label
                                htmlFor="run-out-of-client-ad-account"
                                style={{
                                  marginLeft: "0.5rem",
                                  fontWeight: this.state
                                    .run_out_of_client_ad_account
                                    ? "900"
                                    : "500",
                                  cursor: "pointer",
                                }}
                              >
                                Ads run out of client ad account
                              </label>
                            </div>
                            {this.state.run_out_of_client_ad_account ? (
                              <div style={{ marginBottom: ".75rem" }}>
                                <input
                                  type="checkbox"
                                  id="spend-out-of-client-account"
                                  style={{
                                    padding: ".5rem",
                                    cursor: "pointer",
                                  }}
                                  checked={
                                    this.state.spend_out_of_client_account
                                  }
                                  disabled={this.props.accessLevel !== 2}
                                  onChange={(e) => {
                                    this.onChangeMediaSpendAccount(e);
                                  }}
                                />
                                <label
                                  htmlFor="spend-out-of-client-account"
                                  style={{
                                    marginLeft: "0.5rem",
                                    fontWeight: this.state
                                      .spend_out_of_client_account
                                      ? "900"
                                      : "500",
                                    cursor: "pointer",
                                  }}
                                >
                                  Client also pays for media spend
                                </label>
                                <div style={{ marginTop: ".25rem" }}>
                                  <small>
                                    Only check this box if the client is paying
                                    directly for ad spend under their own
                                    account/credit card.
                                  </small>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        ) : null}
                        {this.state.campaigns ? (
                          <ul
                            style={{
                              listStyle: "none",
                              padding: "0",
                              marginTop: "0",
                            }}
                          >
                            {this.state.campaigns.length ? (
                              this.state.campaigns.map((item, i) => (
                                <li
                                  key={`campaign-${i}`}
                                  className="single-campaign-registration"
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: ".25rem",
                                      alignItems: "center",
                                      overflowWrap: "anywhere",
                                    }}
                                  >
                                    {item.platform_key ? (
                                      <img
                                        src={`/assets/platform-${item.platform_key.toLowerCase()}.png`}
                                        alt={item.text}
                                        style={{
                                          height: "1.5rem",
                                          lineHeight: "1.5rem",
                                          marginRight: ".5rem",
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={`/assets/platform-adcell.jpg`}
                                        alt={`Adcellerant`}
                                        style={{
                                          height: "1.5rem",
                                          lineHeight: "1.5rem",
                                          marginRight: ".5rem",
                                        }}
                                      />
                                    )}
                                    <button
                                      className="registered-campaign-link"
                                      onClick={() =>
                                        self.handleEditCampaign(
                                          item.campaign_id,
                                        )
                                      }
                                    >
                                      {item.generated_campaign_name}
                                    </button>
                                  </div>
                                </li>
                              ))
                            ) : (
                              <li className="gray-text">
                                No campaigns registered.
                              </li>
                            )}
                          </ul>
                        ) : (
                          <div
                            style={{ margin: "1rem 0", fontStyle: "italic" }}
                          >
                            Loading...
                          </div>
                        )}
                        <Button onClick={() => self.handleRegister()}>
                          Register Campaign
                        </Button>
                      </div>
                    ) : null}
                  </Grid.Column>
                  <Grid.Column width={10} computer={10} mobile={16}>
                    <Header as="h3">IO Product Info</Header>

                    {!empty(this.state.ioProductData[397]) ? (
                      <div style={{ padding: "1em .5em" }}>
                        <strong>NOTE:</strong> {self.state.ioProductData[397]}
                      </div>
                    ) : null}

                    {!empty(this.props.ioProduct.flights) ? (
                      <div
                        key={"io-product-render-field-flights"}
                        className="flagship-single-field single-record-single-field"
                      >
                        {renderFieldValue(
                          this.props.ioProduct.flights,
                          this.props.ioProduct.io_product_type ===
                            "email-marketing"
                            ? "deployment"
                            : "flight",
                        )}
                      </div>
                    ) : null}

                    {!empty(this.state.ioProductForm)
                      ? this.state.ioProductForm.map(function (item) {
                          if (!empty(self.state.ioProductData)) {
                            let value = self.state.ioProductData.hasOwnProperty(
                              item.field_id,
                            )
                              ? self.state.ioProductData[item.field_id]
                              : "";

                            return !empty(value) &&
                              shouldShowField(
                                item,
                                self.state.ioProductData,
                              ) ? (
                              <div
                                key={"io-product-render-field-" + item.field_id}
                                className="flagship-single-field single-record-single-field"
                              >
                                {!empty(item.label) ? (
                                  <div>
                                    <Label>{item.label}</Label> <br />
                                  </div>
                                ) : null}
                                <div className="field-value">
                                  {item.type === "textarea" ? (
                                    <Linkify properties={{ target: "_blank" }}>
                                      {renderFieldValue(value, item.validation)}
                                    </Linkify>
                                  ) : (
                                    renderFieldValue(value, item.validation)
                                  )}
                                </div>
                              </div>
                            ) : null;
                          }
                        })
                      : "No IO Product data."}
                  </Grid.Column>
                </Grid>
              </div>
            </Modal.Content>
          </Modal>
          {this.state.registeringCampaign ? (
            <RegisterCampaignModal
              market={this.props.market}
              client={this.props.client}
              tier={this.props.tier}
              ioProduct={this.props.ioProduct}
              campaign={this.state.registeringCampaign}
              onClose={this.handleRegisterClose}
            />
          ) : null}
          {this.state.editingCampaign ? (
            <EditCampaignModal
              campaign_id={this.state.editingCampaign}
              market={this.props.market}
              client={this.props.client}
              tier={this.props.tier}
              ioProduct={this.props.ioProduct}
              onClose={this.handleEditCampaignClose}
            />
          ) : null}
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole,
    instance: state.main.instance,
  };
}

export default connect(mapStateToProps, null)(IoProductViewModal);



// WEBPACK FOOTER //
// ./src/components/modals/IoProductViewModal.js